export function ResourceSymbol({ kind }: { kind: "credits" | "components" }) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      {kind === "credits" ? (
        <>
          <path d="M8 12c0-4 24-4 24 0s-24 4-24 0Zm0 0v15c0 5 24 5 24 0V12M8 19c0 5 24 5 24 0" />
          <path d="M13 23v5m6-4v6m6-6v5" opacity=".5" />
        </>
      ) : (
        <>
          <path d="m20 4 13 8v16l-13 8-13-8V12zM7 12l13 8 13-8M20 20v16" />
          <path d="m13 8 14 8v6M7 21l13 8 13-8" opacity=".5" />
        </>
      )}
    </svg>
  );
}
